<div style="background: #F9F9FC">
  <p-toolbar style="color: #F9F9FC">
    <div class="ui-g-12 background">
      <div class="ui-toolbar-group-left ui-g-2" (click)="back()">
        <p-button class="btn-back"  type="p-button" icon="pi pi-angle-left"></p-button>
      </div>
      <div class="ui-g-10">
        <h3 class="subTitle">Especialidades</h3>
      </div>
    </div>
  </p-toolbar>
  <div class="p-grid">
    <div class="p-col-12 p-md-12" *ngIf="providers.length==0 && showSpecialty">
      <p-dataView #dv [value]="specialties" [paginator]="true" [rows]="10" paginatorPosition="bottom" filterBy="strDescription"
                  [sortField]="sortField" [sortOrder]="sortOrder" layout="list" >
        <p-header>
          <div style="position: relative;" class="ui-g-12">
            <input type="search" pInputText placeholder="Búsqueda por especialidad" (input)="dv.filter($event.target.value, 'contains')" style="margin-top: 2%;">
            <i style="float: left; margin: 1px;" class="pi pi-search search-icon"></i>
          </div>
        </p-header>
        <ng-template let-specialty pTemplate="listItem">
          <div class="p-col-12">
            <div class="car-details">
              <div>
                <div class="p-grid" (click)="getProvider(specialty.strDescription)">
                  <div class="p-col-11"> <b>{{specialty.strDescription}}</b></div>
                  <p-button class="p-col-1 btn-dv"  type="p-button"  icon="pi pi-angle-right" ></p-button>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-dataView>
    </div>
    <div #divProviders class="ui-g-12 ui-md-12" *ngIf="providers.length>0 && showProviders">
      <p-dataView #dvDetail [value]="providers" [paginator]="true" [rows]="10" paginatorPosition="bottom" filterBy="name" sortOrder="name" layout="list" >
        <p-header>
          <div style="position: relative">
            <input type="search" pInputText placeholder="Búsqueda por nombre" (input)="dvDetail.filter($event.target.value, 'contains')">
            <i style="float: left" class="pi pi-search search-icon" ></i>
          </div>
        </p-header>
        <ng-template let-provider pTemplate="listItem">
          <div class="p-col-12 p-md-3">
            <div class="car-details">
              <div>
                <div class="p-grid" (click)="selectProvider($event, provider)">
                  <div class="p-col-11"><b>{{provider.name}}</b></div>

                  <!--<div *ngIf="provider.offline !== null" class="p-col-11">Estado: <b>{{provider.offline}}</b></div>
                  <div *ngIf="provider.queque !== null" class="p-col-11">Cola de Espera: <b>{{provider.queque}}</b></div>-->
                  <p-button class="p-col-1 btn-dv"  type="p-button" icon="pi pi-angle-right" >Detalles</p-button>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-dataView>
    </div>
  </div>
</div>
<div class="p-grid">
    <p-dialog closable="true" header="Ubicaciones de " [(visible)]="displayDialogUbication" [minY]="70" [modal]="true"
          [style]="{width: '80%', height:'80%'}"  [contentStyle]="{padding: '2em', textAlign: 'center'}" >
  <div class="p-col-12 p-md-12" *ngIf="infoProviders.length>0">
<!--  BOTON DE TELEMEDICINA  <p-button  class="p-col-1 btn-dv"  type="p-button"  icon="pi pi-angle-right" (click)="telemedicine()" >{{quequeVariable}}</p-button>-->
    <p-dataView #dvInfo [value]="infoProviders" [paginator]="true" [rows]="10" paginatorPosition="bottom" filterBy="name" sortOrder="name" layout="list" >
      <p-header>
        <div style="position: relative">
          <input type="search" pInputText placeholder="Búsqueda por nombre" (input)="dvInfo.filter($event.target.value, 'contains')">
          <i style="float: left" class="pi pi-search search-icon" ></i>
        </div>
      </p-header>
      <ng-template let-info pTemplate="listItem">
        <div class="p-col-12 p-md-3">
          <div class="car-details">
            <div>
              <div class="p-grid" (click)="selectedLocation($event, info)">
                <div class="p-col-11"><b>{{info.name}}</b></div>
                <div class="p-col-11">{{info.fullAddress}}</div>
                <p-button class="p-col-1 btn-dv"  type="p-button" icon="pi pi-angle-right" ></p-button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </p-dataView>
  </div>
</p-dialog>
</div>

<p-dialog closable="true" header="Detalles de Proveedor" [(visible)]="displayDialog" [minY]="70" showEffect="fade" [modal]="true"
          [style]="{width: '80%', height:'80%'}"  [contentStyle]="{padding: '2em', textAlign: 'center'}">
  <div *ngIf="selectedProvider" class="div-container-dialog-center">
    <img class="img-dialog-center" src="../../assets/images/medicina%20interna.png">
    <div style="width: 120px">
      <p-button  id="selectFile"  label="Favoritos">
        <img src="../../assets/images/icon_star.svg" style="float: left; margin: 4px;">
      </p-button>
    </div>
    <div style="width: auto; text-align: end">
      <h2>Q350.00</h2>
    </div>
    <div style="width: auto; text-align: start; border-bottom: #24292e">
      <h3>Fecha: 02/07/2020</h3>
      <h3>Consulta</h3>
    </div>
    <div style="background: #24292e;height: 2px;"></div>
    <div style="width: auto; text-align: start;">
      <h3>{{selectedProvider.idProvider.name}}</h3>
      <h3>{{selectedProvider.name}}</h3>
      <h3>{{selectedProvider.fullAddress}}</h3>
    </div>
    <div style="width: 150px; text-align: center; margin-top: 20px; margin-left: auto; margin-right: auto;" class="p-grid">
      <p-button     label="-" (click)="minus()" style="width: auto; margin: 10px"></p-button>
      <h3 style="margin: 10px">{{cant}}</h3>
      <p-button    label="+" (click)="cant=cant+1" style="width: auto; margin: 10px"></p-button>
    </div>
    <p-button    label="Agregar al carrito"  style="width: auto; margin: 10px"></p-button>
  </div>
</p-dialog>
<p-dialog closable="true" header="¡Esperando que la Doctora o el Doctor acepte! " [(visible)]="displayWaitDialog" [minY]="70" [modal]="true"
          [style]="{width: '80%', height:'80%'}"  [contentStyle]="{padding: '2em', textAlign: 'center'}">
</p-dialog>
